import { makeStyles, withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

export const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 30,
        flexGrow: 1,
        borderRadius: 12,
        border: '1px solid #D4DDE4',
        width: '100%',
    },
    heading: {
        margin: 0,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#091E42',
        margin: '25px 25px',
    },
    appBar: {
        height: 72,
        borderRadius: '12px 12px 0 0',
        backgroundColor: '#E6EDF3',
        justifyContent: 'center',
        padding: '0px 20px',
    },
    tab: {
        height: 72
    },
    tabContainer: {
        width: '96%',
        // minWidth: 650,
        borderRadius: 12,
        margin: '25px 2%'
    },
    tabContainerOne: {
        width: '100%',
        "@media (max-width: 1200px)": {
            overFlowY:'scroll'
        },
       
    },
    tabHead: {
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#091E42',
        fontFamily: 'Roboto-SemiBold',
        textTransform:'capitalize'
    },
    tabHeadText: {
        margin: 0,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#091E42',
        paddingBottom: 15,
    },
    cellContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        // marginRight: 59
    },
    tabInnerTextDivContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    tabInnerTextDiv: {
        display: 'flex',
        alignItems: 'center',
        marginRight: 20,
        "@media (max-width: 1200px)": {
            width: '120px',
        },
    },
    tabInnerText: {
        margin: 0,
        color: '#5B6773',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: 16,
    },
    tabInnerIcon: {
        color: '#94999E',
        width: 20,
        height: 20,
        // marginRight: 8
    },
    priceText: {
        margin: 0,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#091E42',
        "@media (min-width: 1800px)": {
            marginRight: 59,
        },
    },
    selected: {
        width: 'auto',
        paddingLeft: 10,
        paddingRight: 10,
        height: 42,
        background: 'linear-gradient(#824ED2, #B07DFF)',
        borderRadius: 6,
        marginRight: 55,
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    notSelected: {
        width: 'auto',
        paddingLeft: 10,
        paddingRight: 10,
        height: 42,
        borderRadius: 6,
        marginRight: 55,
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tabHead: {
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#091E42',
        fontFamily: 'Roboto-SemiBold',
    },
    activeTab: {
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#FFFFFF',
        fontFamily: 'Roboto-SemiBold',
    },

}));

export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#5B6773',
        color: '#ffffff',
        height: 52,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 16,
        paddingLeft: 30
    },
    body: {
        fontSize: 14,
        height: 52,
        color: '#5B6773',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 16,
        paddingLeft: 30
    },
}))(TableCell);

export const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F4F6F8',
        },
    },
}))(TableRow);
